export default __webpack_public_path__ + "static/media/grafema_severe_06.2f2ba6c6.jpg";